import moment from 'moment';
import 'moment/locale/fr';
import { FaArrowRight, FaCalendarDays, FaLocationDot } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { IMeeting } from '../../../../types';
import { IconWrapper } from '../../../IconWrapper/IconWrapper';
import styles from './Meetings.module.scss';

interface IMeetingsProps {
  meetings: IMeeting[];
}

const Meetings = ({ meetings }: IMeetingsProps) => {
  const navigate = useNavigate();
  const sortedMeetings = [...meetings].sort(
    (a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime()
  );

  if (sortedMeetings.length === 0) {
    return (
      <div className={styles.Empty}>
        <div className={styles.EmptyIcon}><IconWrapper icon={FaCalendarDays} /></div>
        <h2>No meetings yet</h2>
        <p>Create your first meeting to start organizing your activities.</p>
      </div>
    );
  }

  return (
    <div className={styles.Grid}>
      {sortedMeetings.map((meeting) => {
        const eventDate = moment(meeting.event_date);
        const isPast = eventDate.isBefore(moment());
        return (
          <button
            type="button"
            className={styles.MeetingCard}
            key={meeting._id}
            onClick={() => navigate(`/meeting/${meeting._id}`)}
          >
            <div className={styles.CardTop}>
              <span className={`${styles.Status} ${isPast ? styles.Past : styles.Upcoming}`}>
                {isPast ? 'Completed' : 'Upcoming'}
              </span>
              <span className={styles.Arrow}><IconWrapper icon={FaArrowRight} /></span>
            </div>
            <h2 className={styles.Name}>{meeting.name}</h2>
            <div className={styles.Detail}>
              <IconWrapper icon={FaCalendarDays} />
              <span>{eventDate.format('LL')} · {eventDate.format('HH:mm')}</span>
            </div>
            <div className={styles.Detail}>
              <IconWrapper icon={FaLocationDot} />
              <span>{meeting.city}{meeting.site ? ` · ${meeting.site}` : ''}</span>
            </div>
            <div className={styles.Footer}>Answer before {moment(meeting.answer_before).format('LL')}</div>
          </button>
        );
      })}
    </div>
  );
};

export default Meetings;
